<div class="login-background">
    <div class="login-block">
        <div id="errorMessage">
            @if (requestState === RequestRestorePasswordState.SendedEmail) {
                Er is een e-mail verstuurd naar <b>{{ form.value.email }}</b
                >. Via de link in deze e-mail kun je een nieuw wachtwoord instellen. <br /><br />
                <b>E-mail niet ontvangen?</b><br />
                Controleer of deze in spam terecht is gekomen en voeg
                <a href="mailto:{{ environment.fromEmail }}">{{ environment.fromEmail }}</a>
                toe aan de lijst met veilige afzenders.
                <br /><br />
                <a class="textlink back" routerLink="/login">Terug naar het inlogscherm</a>
            } @else if (requestState === RequestRestorePasswordState.SendEmailFail) {
                {{
                    errorMessage ||
                        'Het is niet gelukt om een e-mail te versturen. Probeer het nog een keer, want het ligt niet aan jou.'
                }}
                <br /><br />
                <button mat-raised-button (click)="tryAgain()" color="primary">Probeer het opnieuw</button>
            }
        </div>
        @if (
            requestState === RequestRestorePasswordState.FillInEmail ||
            requestState === RequestRestorePasswordState.SendingEmail
        ) {
            <form [formGroup]="form">
                <div class="title">
                    <h1 class="h4 condensed">Wachtwoord vergeten</h1>
                    <p>Vul hier uw e-mailadres in om uw wachtwoord te resetten.</p>
                </div>
                <mat-form-field id="email" appearance="fill">
                    <mat-label>E-mailadres</mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="email"
                        name="email"
                        autocomplete="email"
                        placeholder="Vul uw e-mailadres in" />
                    <mat-error>Vul een correct e-mailadres in</mat-error>
                </mat-form-field>
                <div class="login-buttons">
                    <button
                        id="btn-request-password"
                        [disabled]="form.invalid || requestState === RequestRestorePasswordState.SendingEmail"
                        (click)="requestPasswordEmail()"
                        mat-raised-button
                        color="primary">
                        <ng-container *ngIf="requestState === RequestRestorePasswordState.FillInEmail">
                            Wachtwoord opvragen
                        </ng-container>
                        <ng-container *ngIf="requestState === RequestRestorePasswordState.SendingEmail">
                            Link wordt verstuurd...
                        </ng-container>
                    </button>
                </div>
            </form>
        }
    </div>
</div>
